import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { productHomeList } from '../../data/localData'
import { Link } from 'react-router-dom'
import { GoArrowUpRight } from 'react-icons/go'

function ProductList() {
    return (
        <div className='home-gap home-product-list pb-5'>
            <Container>
                <h2 className='m-0 fs-48 fw-semibold text-center fs-md-25 fs-sm-25 pb-4' data-aos="zoom-in">Product We Manufactring</h2>
                <Row className='gy-3'>
                    {
                        productHomeList.map((product, index) => {
                            return (
                                <Col key={index} className='col-12 col-sm-6 col-lg-3 pt-2' data-aos="fade-up">
                                    <div className='home-product-list-items d-grid gap-2 gap-sm-3 p-2 p-sm-3'>
                                        <Link to={product?.link} className='flex-between-align'>
                                            <h5 className='fs-18 fs-sm-16 m-0 fw-semibold'>{product?.name}</h5>
                                            <span className='share-icon'><GoArrowUpRight /></span>
                                        </Link>
                                        <Link to={product?.link} className='img-holder'>
                                            <img src={product?.image} alt="" />
                                        </Link>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}

export default ProductList